/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResult_List_CombinedOfferV7Response__ } from '../models/ApiResult_List_CombinedOfferV7Response__';
import type { BookingValidityDto } from '../models/BookingValidityDto';
import type { CancelCondRequestDto } from '../models/CancelCondRequestDto';
import type { CancelCondResponseDto } from '../models/CancelCondResponseDto';
import type { CancelRequestDto } from '../models/CancelRequestDto';
import type { CancelResponseDto } from '../models/CancelResponseDto';
import type { ConfigDto } from '../models/ConfigDto';
import type { ConnectionData } from '../models/ConnectionData';
import type { ConnectionDetails } from '../models/ConnectionDetails';
import type { ConnectionResponseDto } from '../models/ConnectionResponseDto';
import type { CountryData } from '../models/CountryData';
import type { FinalizeRequestDto } from '../models/FinalizeRequestDto';
import type { FinalizeResponseDto } from '../models/FinalizeResponseDto';
import type { InitStartRequest } from '../models/InitStartRequest';
import type { InitStartResponse } from '../models/InitStartResponse';
import type { InsuranceOfferRequest } from '../models/InsuranceOfferRequest';
import type { InsuranceOfferResponse } from '../models/InsuranceOfferResponse';
import type { InsuranceRequestDto } from '../models/InsuranceRequestDto';
import type { InsuranceResponseDto } from '../models/InsuranceResponseDto';
import type { OfferData } from '../models/OfferData';
import type { OfferRequest } from '../models/OfferRequest';
import type { PaymentRequestDto } from '../models/PaymentRequestDto';
import type { PaymentResponseDto } from '../models/PaymentResponseDto';
import type { PrebookRequestDto } from '../models/PrebookRequestDto';
import type { PrebookResponseDto } from '../models/PrebookResponseDto';
import type { ResendEmailDto } from '../models/ResendEmailDto';
import type { TicketLinkDto } from '../models/TicketLinkDto';
import type { TicketResponseDto } from '../models/TicketResponseDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class DefaultService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param token
     * @param lang
     * @returns any finalizeNotification 200 response
     * @throws ApiError
     */
    public finalizeNotification(
        token: string,
        lang?: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/booking/finalize',
            query: {
                'token': token,
                'lang': lang,
            },
        });
    }
    /**
     * @param requestBody
     * @returns FinalizeResponseDto finalize 200 response
     * @throws ApiError
     */
    public finalize(
        requestBody: FinalizeRequestDto,
    ): CancelablePromise<FinalizeResponseDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/booking/finalize',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns InsuranceResponseDto createInsuranceContract 200 response
     * @throws ApiError
     */
    public createInsuranceContract(
        requestBody: InsuranceRequestDto,
    ): CancelablePromise<InsuranceResponseDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/booking/insurance',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param ticketId
     * @returns BookingValidityDto getBookingValidity 200 response
     * @throws ApiError
     */
    public getBookingValidity(
        ticketId: string,
    ): CancelablePromise<BookingValidityDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/booking/offerValid',
            query: {
                'ticketId': ticketId,
            },
        });
    }
    /**
     * @param requestBody
     * @returns PaymentResponseDto paymentInitialization 200 response
     * @throws ApiError
     */
    public paymentInitialization(
        requestBody: PaymentRequestDto,
    ): CancelablePromise<PaymentResponseDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/booking/payment-initialization',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns PrebookResponseDto prebook 200 response
     * @throws ApiError
     */
    public prebook(
        requestBody: PrebookRequestDto,
    ): CancelablePromise<PrebookResponseDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/booking/prebook',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any resendConfirmationEmail 200 response
     * @throws ApiError
     */
    public resendConfirmationEmail(
        requestBody: ResendEmailDto,
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/booking/resendEmail',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param ticketId
     * @returns string getTaxCertificate 200 response
     * @throws ApiError
     */
    public getTaxCertificate(
        ticketId: string,
    ): CancelablePromise<Array<string>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/booking/taxCertificate/{ticketID}',
            path: {
                'ticketID': ticketId,
            },
        });
    }
    /**
     * @returns ConfigDto getConfig 200 response
     * @throws ApiError
     */
    public getConfig(): CancelablePromise<ConfigDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/config',
        });
    }
    /**
     * @param evaFrom
     * @param evaTo
     * @param date
     * @param skip
     * @returns ConnectionResponseDto findConnections 200 response
     * @throws ApiError
     */
    public findConnections(
        evaFrom: string,
        evaTo: string,
        date: string,
        skip: number,
    ): CancelablePromise<ConnectionResponseDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/connection/{evaFrom}/{evaTo}/{date}',
            path: {
                'evaFrom': evaFrom,
                'evaTo': evaTo,
                'date': date,
            },
            query: {
                'skip': skip,
            },
        });
    }
    /**
     * @param fromCountry
     * @param carTransport
     * @returns CountryData getCountriesFromCountry 200 response
     * @throws ApiError
     */
    public getCountriesFromCountry(
        fromCountry: string,
        carTransport: boolean = false,
    ): CancelablePromise<Array<CountryData>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/countries/from/country/{fromCountry}',
            path: {
                'fromCountry': fromCountry,
            },
            query: {
                'carTransport': carTransport,
            },
        });
    }
    /**
     * @param fromStation
     * @param carTransport
     * @returns CountryData getCountriesFromStation 200 response
     * @throws ApiError
     */
    public getCountriesFromStation(
        fromStation: string,
        carTransport: boolean = false,
    ): CancelablePromise<Array<CountryData>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/countries/from/station/{fromStation}',
            path: {
                'fromStation': fromStation,
            },
            query: {
                'carTransport': carTransport,
            },
        });
    }
    /**
     * @param toCountry
     * @param carTransport
     * @returns CountryData getCountriesToCountry 200 response
     * @throws ApiError
     */
    public getCountriesToCountry(
        toCountry: string,
        carTransport: boolean = false,
    ): CancelablePromise<Array<CountryData>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/countries/to/country/{toCountry}',
            path: {
                'toCountry': toCountry,
            },
            query: {
                'carTransport': carTransport,
            },
        });
    }
    /**
     * @param toStation
     * @param carTransport
     * @returns CountryData getCountriesToStation 200 response
     * @throws ApiError
     */
    public getCountriesToStation(
        toStation: string,
        carTransport: boolean = false,
    ): CancelablePromise<Array<CountryData>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/countries/to/station/{toStation}',
            path: {
                'toStation': toStation,
            },
            query: {
                'carTransport': carTransport,
            },
        });
    }
    /**
     * @param fromCountry
     * @param toCountry
     * @param date
     * @param carTransport
     * @returns ConnectionData getCountryToCountryConnections 200 response
     * @throws ApiError
     */
    public getCountryToCountryConnections(
        fromCountry: string,
        toCountry: string,
        date: string,
        carTransport: boolean = false,
    ): CancelablePromise<Array<ConnectionData>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/destinations/country/{fromCountry}/country/{toCountry}/{date}',
            path: {
                'fromCountry': fromCountry,
                'toCountry': toCountry,
                'date': date,
            },
            query: {
                'carTransport': carTransport,
            },
        });
    }
    /**
     * @param fromCountry
     * @param toStation
     * @param date
     * @param carTransport
     * @returns ConnectionData getCountryToStationConnections 200 response
     * @throws ApiError
     */
    public getCountryToStationConnections(
        fromCountry: string,
        toStation: string,
        date: string,
        carTransport: boolean = false,
    ): CancelablePromise<Array<ConnectionData>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/destinations/country/{fromCountry}/station/{toStation}/{date}',
            path: {
                'fromCountry': fromCountry,
                'toStation': toStation,
                'date': date,
            },
            query: {
                'carTransport': carTransport,
            },
        });
    }
    /**
     * @param date
     * @param carTransport
     * @returns ConnectionData getDaniConnections 200 response
     * @throws ApiError
     */
    public getDaniConnections(
        date: string,
        carTransport: boolean = false,
    ): CancelablePromise<Array<ConnectionData>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/destinations/dani/{date}',
            path: {
                'date': date,
            },
            query: {
                'carTransport': carTransport,
            },
        });
    }
    /**
     * @param trainNumber
     * @param fromStation
     * @param toStation
     * @param time
     * @param forward
     * @returns OfferData getOffersForTrain 200 response
     * @throws ApiError
     */
    public getOffersForTrain(
        trainNumber: string,
        fromStation: string,
        toStation: string,
        time: string,
        forward: boolean = true,
    ): CancelablePromise<Array<OfferData>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/destinations/offers/{trainNumber}/{fromStation}/{toStation}/{time}',
            path: {
                'trainNumber': trainNumber,
                'fromStation': fromStation,
                'toStation': toStation,
                'time': time,
            },
            query: {
                'forward': forward,
            },
        });
    }
    /**
     * @param date
     * @param carTransport
     * @returns ConnectionData getPartnerConnections 200 response
     * @throws ApiError
     */
    public getPartnerConnections(
        date: string,
        carTransport: boolean = false,
    ): CancelablePromise<Array<ConnectionData>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/destinations/partner/{date}',
            path: {
                'date': date,
            },
            query: {
                'carTransport': carTransport,
            },
        });
    }
    /**
     * @param fromStation
     * @param toCountry
     * @param date
     * @param carTransport
     * @returns ConnectionData getStationToCountryConnections 200 response
     * @throws ApiError
     */
    public getStationToCountryConnections(
        fromStation: string,
        toCountry: string,
        date: string,
        carTransport: boolean = false,
    ): CancelablePromise<Array<ConnectionData>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/destinations/station/{fromStation}/country/{toCountry}/{date}',
            path: {
                'fromStation': fromStation,
                'toCountry': toCountry,
                'date': date,
            },
            query: {
                'carTransport': carTransport,
            },
        });
    }
    /**
     * @param trainNumber
     * @param date
     * @returns ConnectionDetails getConnectionDetails 200 response
     * @throws ApiError
     */
    public getConnectionDetails(
        trainNumber: string,
        date: string,
    ): CancelablePromise<ConnectionDetails> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/destinations/train/{trainNumber}/{date}',
            path: {
                'trainNumber': trainNumber,
                'date': date,
            },
        });
    }
    /**
     * @param requestBody
     * @param lang
     * @returns InsuranceOfferResponse getInsuranceOffer 200 response
     * @throws ApiError
     */
    public getInsuranceOffer(
        requestBody: InsuranceOfferRequest,
        lang: string = 'de',
    ): CancelablePromise<InsuranceOfferResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/erv/offer',
            query: {
                'lang': lang,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param ticketId
     * @param language
     * @returns TicketLinkDto getTicketLink 200 response
     * @throws ApiError
     */
    public getTicketLink(
        ticketId: string,
        language?: string | null,
    ): CancelablePromise<TicketLinkDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/fulfillment',
            query: {
                'ticketId': ticketId,
                'language': language,
            },
        });
    }
    /**
     * @param ticketId
     * @param language
     * @returns binary createPDF 200 response
     * @throws ApiError
     */
    public createPdf(
        ticketId: string,
        language?: string | null,
    ): CancelablePromise<Blob> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/fulfillment/createPDF',
            query: {
                'ticketId': ticketId,
                'language': language,
            },
        });
    }
    /**
     * @param requestBody
     * @returns InitStartResponse start 200 response
     * @throws ApiError
     */
    public start(
        requestBody: InitStartRequest,
    ): CancelablePromise<InitStartResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/init/start',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param limit
     * @returns any brands 200 response
     * @throws ApiError
     */
    public brands(
        limit?: number | null,
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/motorail/brands',
            query: {
                'limit': limit,
            },
        });
    }
    /**
     * @param code
     * @returns any get 200 response
     * @throws ApiError
     */
    public get(
        code?: string | null,
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/motorail/carType',
            query: {
                'code': code,
            },
        });
    }
    /**
     * @param code
     * @param limit
     * @returns any find 200 response
     * @throws ApiError
     */
    public find(
        code?: string | null,
        limit?: number | null,
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/motorail/find',
            query: {
                'code': code,
                'limit': limit,
            },
        });
    }
    /**
     * @returns any motorbikes 200 response
     * @throws ApiError
     */
    public motorbikes(): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/motorail/motorbikes',
        });
    }
    /**
     * @param requestBody
     * @returns ApiResult_List_CombinedOfferV7Response__ getOffers 200 response
     * @throws ApiError
     */
    public getOffers(
        requestBody: OfferRequest,
    ): CancelablePromise<ApiResult_List_CombinedOfferV7Response__> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/offer/get',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param limit
     * @param name
     * @param evaFrom
     * @param evaTo
     * @param lang
     * @param country
     * @returns any findStations 200 response
     * @throws ApiError
     */
    public findStations(
        limit?: number | null,
        name?: string | null,
        evaFrom?: string | null,
        evaTo?: string | null,
        lang?: string | null,
        country?: string | null,
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/stations/find',
            query: {
                'limit': limit,
                'name': name,
                'evaFrom': evaFrom,
                'evaTo': evaTo,
                'lang': lang,
                'country': country,
            },
        });
    }
    /**
     * @param lang
     * @param number
     * @returns any getStation 200 response
     * @throws ApiError
     */
    public getStation(
        lang?: string | null,
        number?: string | null,
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/stations/get',
            query: {
                'lang': lang,
                'number': number,
            },
        });
    }
    /**
     * @param ticketId
     * @param lang
     * @returns TicketResponseDto getTicketData 200 response
     * @throws ApiError
     */
    public getTicketData(
        ticketId: string,
        lang: string = 'de',
    ): CancelablePromise<TicketResponseDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/ticket',
            query: {
                'ticketId': ticketId,
                'lang': lang,
            },
        });
    }
    /**
     * @param requestBody
     * @returns CancelResponseDto cancel 200 response
     * @throws ApiError
     */
    public cancel(
        requestBody: CancelRequestDto,
    ): CancelablePromise<CancelResponseDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/ticket/cancel',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns CancelCondResponseDto cancelCondition 200 response
     * @throws ApiError
     */
    public cancelCondition(
        requestBody: CancelCondRequestDto,
    ): CancelablePromise<CancelCondResponseDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/ticket/cancel-condition',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
